import React from 'react';
import { store } from '../../redux/store';
import { push } from 'connected-react-router';
import DataTable from '../../components/Table/DataTable';
import Loading from '../../components/Loading/Loading';
import Api from '../../api/Api.js';
import LicenseEndpoints from '../../api/LicenseEndpoints';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Code",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Type",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Status",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Tarrif",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Country",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class ManageLicenses extends React.Component {

    state = {
        licenses: [],
        loading: true
    }

    options = {
        onRowClick: (row) => store.dispatch(push('/license/view/' + row[0]))
    };

    componentDidMount() {
        Api.get(LicenseEndpoints.list)
        .then(({ data }) => {
            this.setState({ licenses: data, loading: false })
        })
        .catch((e) => { 
            this.setState({ loading: false });
            console.error(e);
        })
    }

    render() {
        if(this.state.loading) {
            return <Loading overlay />
        }
        return (
                <DataTable
                    title={"Search Licenses"}
                    data={
                        this.state.licenses
                        .map(license => [license.id, license.product_reference, license.license_services, license.status, license.tarrif, license.country ])
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

export default ManageLicenses;